import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

import { ChangePassword } from "../../components/change-password";

import type { ApiError, ConfirmPasswordRequest } from "@sperrdatei/dto/types";

export const PasswordReset: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | undefined>();
  const [userId, setUserId] = useState<string | undefined>();
  const [verificationCode, setVerfificationCode] = useState<
    string | undefined
  >();

  useEffect(() => {
    const userIdParam = searchParams.get("userId");
    const verificationCodeParam = searchParams.get("verificationCode");

    if (!userIdParam || !verificationCodeParam) {
      setError(
        "Der Link ist fehlerhaft. Bitte nutzen Sie den Link aus der E-Mail",
      );
      return;
    }

    setUserId(userIdParam);
    setVerfificationCode(verificationCodeParam);
  }, [searchParams]);

  const handleSubmit = async (
    password: string,
  ): Promise<ApiError | undefined> => {
    if (!userId || !verificationCode) {
      return;
    }

    const confirmPasswordRequest: ConfirmPasswordRequest = {
      userId,
      verificationCode,
      password,
    };

    const response = await fetch("/api/user/password/confirm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(confirmPasswordRequest),
    });

    if (!response.ok) {
      return response.json();
    }
  };

  return error ? (
    <div className="container mt-2">
      <div className="alert alert-danger" role="alert">
        <h4 className="alert-heading">
          <i className="bi bi-exclamation-triangle-fill"></i> Fehler
        </h4>
        <p className="mb-0">{error}</p>
      </div>
    </div>
  ) : (
    <ChangePassword
      successTitle="Passwort geändert"
      successMessage="Sie können sich jetzt mit ihrer E-Mail-Adresse und dem neuen Passwort"
      submitAction={handleSubmit}
    />
  );
};
